import { combineReducers, Reducer } from '@reduxjs/toolkit';
import sharedAssetReducer from '../asset/reducer';
import assetGridReducer from '../../features/AssetGrid/redux/assetGridSlice';
import riskReducer from '../risk/reducer';
import filterReducer from '../../features/useFilters/filterSlice';
import inspectionReducer from '../inspections/reducer';
import facilityReducer from '../facility/reducer';
import polygonHighlightReducer from '../../features/polygonHighlight/polygonHighlightSlice';
import { moduleNamespace } from '../store.config';

export const reducers: Record<string, Reducer> = {
	[moduleNamespace]: combineReducers({
		asset: sharedAssetReducer,
		assetGrid: assetGridReducer,
		risk: riskReducer,
		filter: filterReducer,
		inspection: inspectionReducer,
		facility: facilityReducer,
		polygonHighlight: polygonHighlightReducer,
	}),
};

export default reducers;
